function teams(){
    return {
        red:{
            score: 0,
            basket:[]
        },
        blue:{
            score:0,
            basket:[]
        }
    };
}
export default {
    namespaced: true,
    state: {
        title: 'GAME STARTS IN',
        gameTimer: 0,
        players: {},
        status: "closed",
        teams: teams(),
        team: "",
        holding: null
    },
    getters: {
        gameTimer: state => {
            return state.gameTimer;
        },
        status: state => {
            return state.status;
        },
        players: state => {
            return state.players;
        },
        teams: state => {
            return state.teams;
        },
        team: state => {
            return state.team;
        },
        title: state => {
            return state.title;
        },
        holding: state => {
            return state.holding;
        }
    },
    mutations: {
        setValue(state, data) {
            state[data[0]] = data[1];
        },
        setBasket(state, data) {
            state.teams[data[0]].basket = data[1];
        },
        cleanBasket(state, data) {
            state.teams[data[0]].basket = [];
        },
        addToBasket(state, data) {
            state.teams[data[0]].basket.push(data[1]);
        },
        setScore(state, data) {
            state.teams[data[0]].score = data[1];
        },
        setGameStart(state) {
            state.gameTimer = 0;
            state.teams = teams();
            state.holding = null;
            state.title = 'GAME STARTS IN';
        },
        setTitle(state, data) {
            state.title = data;
        },
        decrementGameTimer(state) {
            state.gameTimer--;
        },
    },
    actions: {
        decrementGameTimer({ commit }) {
            commit('decrementGameTimer')
        },
        setValue({ commit }, data) {
            commit('setValue', data)
        },
        setBasket({ commit }, data) {
            commit('setBasket', data)
        },
        cleanBasket({ commit }, data) {
            commit('cleanBasket', data)
        },
        addToBasket({ commit }, data) {
            commit('addToBasket', data)
        },
        setGameStart({ commit }) {
            commit('setGameStart')
        },
        setScore({ commit }, data) {
            commit('setScore', data)
        },
        setGameEnded({ commit }) {
            commit('setGameEnded')
        },
        setTaggersLeft({ commit }, data) {
            commit('setTaggersLeft', data);
        },
        setTitle({ commit }, data) {
            commit('setTitle', data);
        }
    }
};